<template>
    <button
      class="round-button"
      :style="buttonStyle"
    >
      <i :class="iconClass" :style="iconStyle"></i>
    </button>
  </template>
  
  <script>
  export default {
    name: "RoundButton",
    props: {
      iconClass: {
        type: String,
        default: "fas fa-user", // Default icon class
      },
      size: {
        type: Number,
        default: 50, // Default size in pixels
      },
      iconSize: {
        type: String,
        default: "20px", // Default icon size
      },
      iconColor: {
        type: String,
        default: "#333", // Default icon color
      },
      transparentBackground: {
        type: Boolean,
        default: false, // Determines if background is transparent
      },
    },
    computed: {
      buttonStyle() {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`,
          borderRadius: "50%",
          backgroundColor: this.transparentBackground ? "transparent" : "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: this.transparentBackground ? "2px solid #15244d" : "none",
          boxShadow: this.transparentBackground
            ? "none"
            : "0 2px 4px rgba(0, 0, 0, 0.1)",
          cursor: "pointer",
          transition: "background-color 0.3s ease, box-shadow 0.3s ease",
        };
      },
      iconStyle() {
        return {
          fontSize: this.iconSize,
          color: this.iconColor,
        };
      },
    },
  };
  </script>
  
  <style>
  .round-button:hover {
    background-color: #f0f0f0; /* Change background on hover */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Enhance shadow on hover */
  }
  
  .round-button:hover[style*="background-color: transparent"] {
    background-color: transparent; /* Keep transparent background on hover */
    box-shadow: none; /* No shadow for transparent button */
  }
  </style>
  